<div class="half-overlay">
  <ng-content></ng-content>
</div>